export default "__VITE_ASSET__CVmCaGsa__"